export default Object.freeze({
  Pending: 0,
  Sent: 1,
  Error: 2,
  OfflineAgent: 3,
});
